var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content voucher-maintenance" },
    [
      _c("div", { staticClass: "tabs-container" }, [
        _c("div", { staticClass: "grid-view" }, [
          _c(
            "div",
            { staticClass: "main-content voucher-list" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": "2000",
                    reset: true,
                    "custom-sim-query-placeholder": _vm.$t(
                      "Message.QuickSearchChineseName"
                    )
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "triggers",
                      attrs: { slot: "operations" },
                      slot: "operations"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.removeHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.createWTCompanyHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.credit_wtCreateCompany"))
                          )
                        ]
                      ),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticStyle: {
                          width: "20px",
                          height: "18px",
                          margin: "0 auto"
                        },
                        attrs: {
                          src: "/static/info.png",
                          title:
                            "添加平台认证合作伙伴，与“沃行之家”交互，共建物流生态圈。"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "page-count": _vm.filter.pageCount,
                      "config-module": "20211215",
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize,
                      total: _vm.filter.total
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: function($event) {
                        return _vm.toQueryByPage()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("w-t-application-list-window", {
        attrs: { visible: _vm.openSendList.visible },
        on: { visibleHandler: _vm.visibleHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }